import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const leaveRoom = (roomName: string) => {
  const socket = getOrCreateSocket();
  socket.emit("leave", roomName);
  store.setCurrentRoom(null);
};
